/* eslint-disable */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Popover from '@material-ui/core/Popover';

export const ButtonLink = ({ name, onClick, icon, id, classes, href, target }) =>
    <Button
        className={classes.popoverLinks}
        id={id}
        onClick={onClick}
        variant="outlined"
        href={href}
        target={target}
    >
        {name}
        {icon}
    </Button>;

export const TRPTooltip = withStyles({
    tooltip: {
        backgroundColor: '#043954'
    }
})(Tooltip);

export const ButtonIcon = React.forwardRef((props, ref) => (
    <Button ref={ref} {...props}>
        {props.children}
    </Button>
));

export const BannerBtn = ({ state, classes, children, icon, title, aria, buttonId }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const [hover, setHover] = React.useState(null);

    const handlePopOver = event => {
        setAnchorEl(event.currentTarget);
    };

    const onEnter = () => setHover(true);
    const onLeave = () => setHover(false);

    const handleClose = () => setAnchorEl(null);

    const open = Boolean(anchorEl);
    const id = open ? `${aria}-bluebanner-popover` : undefined;

    const modalState =
        state &&
        Boolean(Object.values(state).filter(modal => modal === true)[0]);

    const determine = modalState ? false : !!open;
    const popoverHandler = determine || open;

    // "data-metrics-location" is a property analytics reads to determine the location of certain items. "PU" stands for "popup"
    // "data-metrics-link-text" is a propery anylitcs reads to give text to buttons or links that only contain icons for tracking purposes
    return (
        <div style={{ paddingTop: 4 }}>
            <TRPTooltip
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 600 }}
                title={title}
                placement="top"
            >
                <Button
                    aria-describedby={id}
                    onClick={handlePopOver}
                    className={classes.button}
                    size="small"
                    onMouseEnter={onEnter}
                    onMouseLeave={onLeave}
                    variant="outlined"
                    data-metrics-link-text={title}
                    id={buttonId}
                >
                    {React.cloneElement(icon, { filled: !!(open || hover) })}
                </Button>
            </TRPTooltip>
            <Popover
                id={id}
                PaperProps={{
                    style: {
                        height: 160,
                        width: 200,
                        padding: 20,
                        marginTop: 16,
                        borderRadius: 0,
                        borderTop: '4px solid #05C3DE'
                    }
                }}
                data-metrics-location='PU'
                open={popoverHandler}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                {children}
            </Popover>
        </div>
    );
};
